import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Project from '@/components/Project'
import Scene from '@/components/Scene'
import Video from '@/components/Video'
import DataDownload from '@/components/DataDownload'
import Qa from '@/components/Qa'
import Edm from '@/components/Edm'
import Manufacturer from '@/components/Manufacturer'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        title: '鼎捷雅典娜 | Tip Biu BI '// 產品介紹
      }
    },
    {
      path: '/project',
      component: Project,
      meta: {
        title: '鼎捷雅典娜 | Tip Biu BI '// 解決方案
      }
    },
    {
      path: '/scene',
      component: Scene,
      meta: {
        title: '鼎捷雅典娜 | Tip Biu BI '//应用场景
      }
    },
    {
      path: '/video',
      component: Video,
      meta: {
        title: '鼎捷雅典娜 | Tip Biu BI '// 影片教學
      }
    },
    {
      path: '/dataDownload',
      component: DataDownload,
      meta: {
        title: '鼎捷雅典娜 | Tip Biu BI '// 知識資料
      }
    },
    {
      path: '/qa',
      component: Qa,
      meta: {
        title: '鼎捷雅典娜 | Tip Biu BI '// FAQ
      }
    },
    {
      path: '/edm',
      name: 'Edm',
      component: Edm,
      meta: {
        title: '鼎捷雅典娜 | Tip Biu BI '// Edm自然人宣传页
      }
    },
    {
      path: '/manufacturer',
      name: 'Manufacturer',
      component: Manufacturer,
      meta: {
        title: '鼎捷雅典娜 | Tip Biu BI '// Edm自然人宣传页
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js